export const FilterCardCollapse = () => {
  const cards = document.querySelectorAll('.js--filter-collapse');

  cards.forEach(card => {
    const boxHeight =card.offsetHeight;
    const parent = card.parentNode;
    const button = parent.querySelector('.js--filter-collapse-btn')

    if (boxHeight > 80) {
      card.classList.add('filter-card--crop');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        let ariaLabelValue = button.getAttribute('aria-expanded');

        if (ariaLabelValue === 'false') {
          button.setAttribute('aria-expanded', 'true');
          card.classList.remove('filter-card--crop');
          card.style.height = boxHeight + "px";
        } else {
          button.setAttribute('aria-expanded', 'false');
          card.classList.add('filter-card--crop');
          card.style.removeProperty("height");
        }
      });
    }
  });
}
